export const LOCATIONS = ["Any", "United States", "UK", "Europe", "UAE", "India", "Singapore", "Canada", "Australia"];
export const DEPARTMENTS = ["Marketing", "Growth", "Performance Marketing", "Product Marketing", "Sales", "Product", "Engineering", "HR / Talent"];
export const SENIORITIES = ["Founder", "C-Level", "VP", "Head", "Director", "Manager", "Recruiter"];
export const CONTACT_TYPES = ["Hiring Manager", "Department Leader", "Executive", "Recruiter", "Talent Acquisition"];
export const EMAIL_REQ = ["Any", "Email available", "Verified email only"];
export const LINKEDIN_REQ = ["Any", "LinkedIn available"];
export const DATA_SOURCES = ["All", "Hunter", "Apollo"];
export const EMAIL_CONF = [70, 80, 90, 95];
export const EXAMPLE_COMPANIES = ["Stripe", "HubSpot", "Notion", "Canva", "Shopify", "Datadog", "Cloudflare", "OpenAI"];

export const scoreColor = (s) => (s >= 90 ? "#059669" : s >= 80 ? "#B45309" : s >= 70 ? "#1D4ED8" : "#52525B");
export const statusColor = (st) => ({
  Verified: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Unverified: "text-amber-700 bg-amber-50 border-amber-200",
  Risky: "text-orange-700 bg-orange-50 border-orange-200",
  Invalid: "text-red-700 bg-red-50 border-red-200",
  Unknown: "text-zinc-600 bg-zinc-100 border-zinc-200",
}[st] || "text-zinc-500 bg-zinc-100 border-zinc-200");
